import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PlaguedForest2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PLAGUED_FOREST2;
}

export default PlaguedForest2PoiTileEntity;
